export default "__VITE_ASSET__kC$XF7rd__"